import { AuthLayout } from '../../../components/AuthLayout';
import { ParagraphStyled } from './styles';

export const EmailConfirmation = () => {
  return (
    <AuthLayout>
      <ParagraphStyled>
        Alteração de e-mail realizada com sucesso!
      </ParagraphStyled>
    </AuthLayout>
  );
};
